module.exports = __webpack_public_path__ + "img/document-dark.75e27256.svg";